import gql from 'graphql-tag';
export default gql`
  mutation UpdateNotFoundById($input: UpdateNotFoundByIdInput!) {
    updateNotFoundById(input: $input) {
      clientMutationId
    }
  }
`;
